import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const CaseDivorceDocumentType1 = union([
    literal("unknown"),
    literal("separation_agreement"),
    literal("consent_order"),
    literal("final_order"),
    literal("court_petition"),
    literal("statement_of_truth"),
]);
export type TCaseDivorceDocumentType1Codec = typeof CaseDivorceDocumentType1;
export type TCaseDivorceDocumentType1 = TTypeOfCodec<typeof CaseDivorceDocumentType1>;
